import React, { useState } from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import { lowerCase, startCase } from "lodash";
import { getCases, esqCases, REEXAM_SEARCH_URL } from "../../services/api-reexam";
import { toDateString, toReexamDetailLink, toPatentDetailLink, toSetString } from "../../helpers/converters";
import TableWithControls from "../common/table-with-controls";
import { withTopCompanies } from "../common/top-companies";

const ExParteTable = ({ filter, accessLevel, companyRenderer }) => {
  const [queries, setQueries] = useState({ sort: "-filing_date", ...filter })
  const fetcher = q => getCases(q).then(json => ({
    data: json.hits.hits.map(e => e._source),
    total: json.hits.total.value,
  }));
  const columns = [
    { dataIndex: "application_number", title: "Application", width: 100, sorter: true, render: val => toReexamDetailLink(val) },
    { dataIndex: "filing_date", title: "Filing Date", width: 100, key: "filing_date", sorter: true, render: toDateString },
    { dataIndex: "application_type", title: "Type", width: 150 },
    { dataIndex: "exparte_status", title: "Status", width: 200, sorter: true },
    { dataIndex: "application_status_date", title: "Last Updated", width: 100, sorter: true, render: toDateString },
    { dataIndex: "invention_title", title: "Title", width: 450, render: val => startCase(lowerCase(val)) },
    { dataIndex: "examiner_art_unit", title: "Art unit", width: 100 },
    { dataIndex: "national_class", title: "Class", width: 100 },
    { dataIndex: "national_subclass", title: "Subclass", width: 100 },
    { dataIndex: "patent_number", title: "Patent", width: 100, key: "patent_number", sorter: true, render: val => toPatentDetailLink(val) },
    { dataIndex: "examiner_name", title: "Examiner", width: 200, render: toSetString },
    { dataIndex: "law_firm", title: "Law Firm", width: 200, sorter: true, render: toSetString },
    { dataIndex: "owner", title: "Owner", width: 200, sorter: true, render: companyRenderer },
    { dataIndex: "requester", title: "Requester", sorter: true, width: 200, render: companyRenderer }
  ];
  const colsDefault = ["application_number", "patent_number", "filing_date", "owner", "requester", "exparte_status", "invention_title"];
  const helmet = {
    title: "Ex Parte Reexamination Case List",
    meta: [{ name: "description", content: "Searchable list of all Ex Parte Reexamination Cases" }]
  };
  return (
    <>
      <Helmet {...helmet} />
      <TableWithControls
        queries={queries}
        fetcher={fetcher}
        onChange={setQueries}
        columns={columns}
        columnKeysSelected={colsDefault}
        rowKey="application_number"
        tableKey="reexamTable"
        size="small"
        shouldSelectColumns={true}
        shouldExport={accessLevel === "full"}
        exportESUrl={REEXAM_SEARCH_URL}
        exportESQueryBuilder={esqCases}
      />
    </>
  )
};

ExParteTable.propTypes = {
  filter: PropTypes.object.isRequired,
  accessLevel: PropTypes.string.isRequired,
  companyRenderer: PropTypes.func.isRequired
};

export default withTopCompanies(ExParteTable);
